module.exports = __webpack_public_path__ + "static/barcode-with-logo-ca74cd8bbca589dfabd325e735e2b8b8.png";